import React from 'react';
import SEO from '../components/SEO';

export default function AboutPage() {
  return (
    <div className="page-container">
      <SEO 
        title="Our Story | CampWhiz"
        description="Discover why we built CampWhiz and how we’re giving parents and camps the power tools they deserve."
      />
      
      <div className="page-content">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-10">
            <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-semibold text-gray-900 mb-4">
              Our Story
            </h1>
          </div>

          <div className="bg-white rounded-lg border border-gray-200">
            <div className="overflow-hidden rounded-t-lg">
              <img
                src="/images/campwhiz-about-us.jpg"
                alt="A real, happy family moment — no poses, no perfection."
                className="w-full h-56 sm:h-72 lg:h-80 object-cover"
              />
            </div>

            <div className="p-8 sm:p-10 lg:p-14 space-y-6">
              <p className="text-lg text-gray-700">
                We started CampWhiz to make camp planning easier for everyone — especially the parents who’ve been piecing it together on their own for years.
              </p>
              <p className="text-lg text-gray-700">
                Like so many families, we’ve done the annual juggle: tabs open, calendars colliding, deadlines missed, and spreadsheets that look like military ops. Whether it’s summer, winter, or just that random “school’s out” week — finding great camps shouldn’t feel like a full-time job.
              </p>
              <p className="text-lg text-gray-700">
                For years, parents have had to wing it. No smart tools, no central place, no sanity.
              </p>
              <p className="text-lg text-gray-700">
                So one late night (somewhere between a color-coded Google Sheet and cold coffee), we decided enough was enough.
              </p>
              <p className="text-lg text-gray-700">
                We built CampWhiz — a simple, friendly platform that helps you find, compare, and plan camps in minutes — without the chaos.
              </p>
              <p className="text-lg text-gray-700">
                And while today it’s all about making discovery and planning easier, our bigger dream is to go even further — to have smart AI helpers that can take care of the scheduling and coordination for you. Because parents deserve real time back, not just better tools.
              </p>
              <p className="text-lg text-gray-700">
                Here’s to giving parents (and camps) the power tools they’ve always deserved — and a few extra hours back in the day.
              </p>
              <div className="pt-6 border-t border-gray-200">
                <p className="text-base text-gray-700">
                  — Carol and Jan Waldeck, Founders &amp; Fellow Exhausted Parents
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

